import { Component, inject } from '@angular/core';
import { DashboardCardComponent } from '../../../../components/organisms/dashboard-card/dashboard-card.component';
import { map, Observable } from 'rxjs';
import { AsyncPipe } from '@angular/common';
import { ProtectedContentComponent } from '../../../../components/organisms/protected-content/protected-content.component';
import { NavigationService } from '../../../../services/navigation.service';
import { HealthService } from '../../../../services/health/health.service';
import { SystemHealth } from '../../../../services/health/health.model';

@Component({
  selector: 'app-dashboard-page',
  imports: [DashboardCardComponent, AsyncPipe, ProtectedContentComponent],
  templateUrl: './dashboard-page.component.html',
  styleUrl: './dashboard-page.component.scss'
})
export class DashboardPageComponent {
  public numberOfDashboardCards = 3;
  private navigationService = inject(NavigationService);
  private healthService = inject(HealthService);

  requiredRoles = this.navigationService.getAccessRoles('admin/dashboard');

  systems$: Observable<SystemHealth[]> = this.healthService
    .getSystemsHealth()
    .pipe(map((systems) => systems.filter((s) => s.name !== 'CONNECTOR')));
}
